module.exports = __webpack_public_path__ + "img/f-zh_HK.248afe69.png";